export default __webpack_public_path__ + "static/media/thumbnail-m-cushion@2x.0b89cc70.png";